import { ReactNode } from 'react';
import { ProductIcon } from 'src/assets/img/product-icon';

export const ProductsOrder = {
  agent: 1,
  customer: 2,
  bi: 3,
} as const;

export type ProductKey = 'agent' | 'bi' | 'customer';

export const ProductsType = {
  agent: 'agent',
  bi: 'bi',
  customer: 'customer',
} as const;

export const ProductsTypeBack = {
  agent: 'coagent',
  bi: 'cobi',
  customer: 'cocustomer',
} as const;

export type ProductTypeBack = (typeof ProductsTypeBack)[keyof typeof ProductsTypeBack];

export const ProductsTypeBackPretty = {
  agent: 'CoAgent',
  bi: 'CoBI',
  customer: 'CoCustomer',
} as const;

export const ProductsTypeColor = {
  agent: 'blue',
  bi: 'yellow',
  customer: 'purple',
} as const;

interface ProductItem {
  label: string;
  icon: ReactNode;
  disabled: boolean;
  target_service: string;
}

export const ProductItems: ProductItem[] = [
  {
    label: 'CoSupport Agent',
    icon: <ProductIcon />,
    disabled: false,
    target_service: 'coagent',
  },
  {
    label: 'CoSupport Customer',
    icon: <ProductIcon variant="customer" />,
    disabled: true,
    target_service: 'cocustomer',
  },
  {
    label: 'CoSupport BI',
    icon: <ProductIcon variant="bi" />,
    disabled: true,
    target_service: 'cobi',
  },
];

export const ProductItemsIcons: Record<ProductKey, ReactNode> = {
  agent: <ProductIcon />,
  bi: <ProductIcon variant="bi" />,
  customer: <ProductIcon variant="customer" />,
};

export const ProductItemsLabels: Record<ProductKey, string> = {
  agent: 'CoSupport Agent',
  bi: 'CoSupport BI',
  customer: 'CoSupport Customer',
};
